export default __webpack_public_path__ + "static/media/facebook.988a0913.svg";